import React, {Component} from 'react';

import {connect} from 'react-redux';
import HomeBookClubCardComponent from '../../components/bookclub/PublicBookClubCardComponent';
import {Card, Segment, Container, Divider, Header, Button} from 'semantic-ui-react';
import * as actionBookClubPublic from "../../redux/actions/bookClubPublic";
import ReactGA from 'react-ga';
import Analytics from "../../middleware/analytics";

export class BookClubListRecruiting extends Component {
    state = {
        ingList: [],
        recruitList: [],
        endedList: []
    };
    componentDidMount = () => {
        this.props.loadBookClubList();

        Analytics.pageViewAll('/bookclub/list/recruiting');
        window.scrollTo(0, 0);
    };


    render() {
        const {
            bookClubListRecruiting,
            bookClubListIng,
            bookClubListEnded,
        } = this.props;
        const recruitListSegment = () => {
            if (bookClubListRecruiting.length === 0) {
                return '현재 모집중인 북클럽이 없습니다.';
            }
            return bookClubListRecruiting.map((bookclub, i) => {
                return <HomeBookClubCardComponent bookclub={bookclub} key={i}/>;
            });
        };
        const ingListSegment = () => {
            if (bookClubListIng.length === 0) {
                return '현재 진행중인 북클럽이 없습니다.';
            }
            return bookClubListIng.map((bookclub, i) => {
                return <HomeBookClubCardComponent bookclub={bookclub} key={i}/>;
            });
        };
        const endedListSegment = () => {
            return bookClubListEnded.map((bookclub, i) => {
                return <HomeBookClubCardComponent bookclub={bookclub} key={i}/>;
            });
        };

        return (
            <div>
                <Segment as={Container} vertical basic>
                    <Header>
                        모집중 북클럽
                    </Header>
                    <Divider/>
                    <Card.Group itemsPerRow={4}
                                stackable>
                        {recruitListSegment()}
                    </Card.Group>
                </Segment>
                <Segment as={Container} vertical basic>
                    <Header>
                        진행중 북클럽
                    </Header>
                    <Divider/>
                    <Card.Group itemsPerRow={4}
                                stackable>
                        {ingListSegment()}
                    </Card.Group>
                </Segment>
                <Segment as={Container} vertical basic>
                    <Header>
                        종료된 북클럽
                    </Header>
                    <Divider/>
                    <Card.Group itemsPerRow={4} stackable>
                        {endedListSegment()}
                    </Card.Group>
                </Segment>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        bookClubListAll,
        bookClubListRecruiting,
        bookClubListIng,
        bookClubListEnded,
        isLoaded,
        failed
    } = state.bookClubPublic
    return {
        bookClubListAll,
        bookClubListRecruiting,
        bookClubListIng,
        bookClubListEnded,
        isLoaded,
        failed
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadBookClubList: () => {
            dispatch(actionBookClubPublic.loadBookClubList())
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BookClubListRecruiting);
